import axiosClient from "./axiosClient";

export async function agencyLogin(agencyId: string, password?: string) {
  try {
    const response = await axiosClient.post("/auth/agency/login", {
      agencyId,
      password: password || "123456",
    });

    if (response.status !== 200) {
      return null;
    }
    return response.data;
  } catch (error: any) {
    console.error("Agency login error", error);
    return null;
  }
}

export async function fetchAgencyBookings(agencyId: string) {
  try {
    const response = await axiosClient.get(`/auth/agency/bookings?agencyId=${agencyId}`);

    if (response.status !== 200) {
      return null;
    }
    return response.data;
  } catch (error: any) {
    console.error("Error fetching agency bookings", error);
    return null;
  }
}
